var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEffortlessDataProtection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 120,
    viewBox: "0 0 114 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.779541,
    width: 112.441,
    height: 120,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_897_8001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.5895 30.1455H23.3595C19.7255 30.1455 16.7795 33.0915 16.7795 36.7255V92.9555C16.7795 96.5895 19.7255 99.5355 23.3595 99.5355H79.5895C83.2236 99.5355 86.1695 96.5895 86.1695 92.9555V36.7255C86.1695 33.0915 83.2236 30.1455 79.5895 30.1455Z",
    fill: "#1A1C26",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2795 20.4551H33.0495C29.4154 20.4551 26.4695 23.401 26.4695 27.0351V83.2651C26.4695 86.8991 29.4154 89.8451 33.0495 89.8451H89.2795C92.9135 89.8451 95.8595 86.8991 95.8595 83.2651V27.0351C95.8595 23.401 92.9135 20.4551 89.2795 20.4551Z",
    fill: "white",
    stroke: "#1A1C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8495 27.2051H37.5495C35.7048 27.2051 34.2095 28.6982 34.2095 30.5401C34.2095 32.3819 35.7048 33.8751 37.5495 33.8751H59.8495C61.6941 33.8751 63.1895 32.3819 63.1895 30.5401C63.1895 28.6982 61.6941 27.2051 59.8495 27.2051Z",
    fill: "#1A1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2496 27.2051H71.7396C70.2539 27.2051 69.0496 28.4094 69.0496 29.8951V31.1851C69.0496 32.6707 70.2539 33.8751 71.7396 33.8751H85.2496C86.7352 33.8751 87.9396 32.6707 87.9396 31.1851V29.8951C87.9396 28.4094 86.7352 27.2051 85.2496 27.2051Z",
    fill: "#1A1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2395 77.375H37.5495C35.7048 77.375 34.2095 78.8681 34.2095 80.71C34.2095 82.5519 35.7048 84.045 37.5495 84.045H51.2395C53.0841 84.045 54.5795 82.5519 54.5795 80.71C54.5795 78.8681 53.0841 77.375 51.2395 77.375Z",
    fill: "#1A1C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0896 68.1155H38.2596C36.0796 68.1155 34.3096 66.3555 34.3096 64.1655V46.1355C34.3096 43.9555 36.0796 42.1855 38.2596 42.1855H40.0896",
    stroke: "#4230E5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2495 42.1855H84.0895C86.2695 42.1855 88.0395 43.9555 88.0395 46.1355V64.1655C88.0395 66.3555 86.2695 68.1155 84.0895 68.1155H82.2495",
    stroke: "#4230E5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3895 49.8354L46.8295 52.3154L49.1995 51.4654C50.4795 51.0054 51.4295 52.6654 50.3995 53.5354L48.4795 55.1554L50.3995 56.7754C51.4395 57.6454 50.4795 59.3054 49.1995 58.8454L46.8295 57.9954L46.3895 60.4754C46.1495 61.8054 44.2395 61.8054 43.9995 60.4754L43.5595 57.9954L41.1895 58.8454C39.9095 59.3054 38.9595 57.6454 39.9895 56.7754L41.9095 55.1554L39.9895 53.5354C38.9495 52.6654 39.9095 51.0054 41.1895 51.4654L43.5595 52.3154L43.9995 49.8354C44.2395 48.5054 46.1495 48.5054 46.3895 49.8354Z",
    fill: "#4230E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3695 49.8354L62.8095 52.3154L65.1795 51.4654C66.4595 51.0054 67.4095 52.6654 66.3795 53.5354L64.4595 55.1554L66.3795 56.7754C67.4195 57.6454 66.4595 59.3054 65.1795 58.8454L62.8095 57.9954L62.3695 60.4754C62.1295 61.8054 60.2195 61.8054 59.9795 60.4754L59.5395 57.9954L57.1695 58.8454C55.8895 59.3054 54.9395 57.6454 55.9695 56.7754L57.8895 55.1554L55.9695 53.5354C54.9295 52.6654 55.8895 51.0054 57.1695 51.4654L59.5395 52.3154L59.9795 49.8354C60.2195 48.5054 62.1295 48.5054 62.3695 49.8354Z",
    fill: "#4230E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3495 49.8354L78.7895 52.3154L81.1595 51.4654C82.4395 51.0054 83.3895 52.6654 82.3595 53.5354L80.4395 55.1554L82.3595 56.7754C83.3995 57.6454 82.4395 59.3054 81.1595 58.8454L78.7895 57.9954L78.3495 60.4754C78.1095 61.8054 76.1995 61.8054 75.9595 60.4754L75.5195 57.9954L73.1495 58.8454C71.8695 59.3054 70.9195 57.6454 71.9495 56.7754L73.8695 55.1554L71.9495 53.5354C70.9095 52.6654 71.8695 51.0054 73.1495 51.4654L75.5195 52.3154L75.9595 49.8354C76.1995 48.5054 78.1095 48.5054 78.3495 49.8354Z",
    fill: "#4230E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_897_8001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.09,
    height: 81.09,
    fill: "white",
    transform: "translate(15.7795 19.4551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortlessDataProtection);
export default __webpack_public_path__ + "static/media/effortless-data-protection.19e3e803a032d38c4f24f68dad0dfe12.svg";
export { ForwardRef as ReactComponent };